/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { ISidebarFeature } from '~views/sidebar/registry';

import styled from 'styled-components';

const GridElementContainer = styled.div`
    display: flex;
`;

export const loadOnDemand = (
    viewFunction: Function,
    viewParams: ISidebarFeature | {} = {}
) => () => {
    const WrappedComponent = React.createElement(viewFunction as any, viewParams as any);

    return React.createElement(GridElementContainer, {}, WrappedComponent);
};
